// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SouthKorea from '../_raw/flag/icon_flag_south_korea.png';

export default () => <img src={SouthKorea} alt="SouthKorea" />;
